import { createStyles, Theme } from "@material-ui/core";
import { borderRadius } from "react-select/src/theme";
export const userStyles = (theme: Theme) =>
  createStyles({
    selectContainer: {
      minWidth: 250,
      border: 'solid 1px rgb(188 188 188)',
      minHeight: 36,
      maxHeight: 90,
      borderRadius: 4,
      padding: '6px 10px',
      overflowX: 'auto',
      cursor: 'pointer',
      '& .icon': {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        padding: '6px 0px'
      },
      '& .multiSelectOptions': {
        background: 'rgb(255 255 255)',
        position: 'absolute',
        zIndex: 9,
        border: 'solid 1px rgb(188 188 188)',
        maxHeight: 200,
        overflowY: 'auto',
        overflowX: 'hidden',
        top: 36,
        left: 0,
        right: 0,
        borderRadius: 4,
        '& .optionItem': {
          padding: '6px 12px 4px',
          '&:hover': {
            background: 'rgb(233 233 233)'
          }
        }  
      },
    },
    activeOptionItem: {
      background: 'rgb(233 233 233)'
    },
    textElipse: {
      width: 200,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
  
    },
    
    customDisabled:{
      backgroundColor: 'rgb(241 240 240) !important',
      color: '#333 !important',
      pointerEvents: 'none',
    },
    searchBox: {
      '&>:first-child': {
        '&>:first-child': {
          marginLeft: 0
        }
      }
    },
    customChip: {
      height: '26px',
      margin: '3px 2px',
      padding: '1px 3px 3px',
      background: 'rgb(244 244 244)',
      lineHeight: '21px',
      borderRadius: 16,
      verticalAlign: 'middle',
      '& .chipLabel': {
        color: '#666',
        padding: '0px 10px 0px',
        fontSize: '12px',
        fontWeight: 400,
        verticalAlign: 'bottom',
      },

      '& .chipIcon': {
        '& svg':{
        color: '#666',
        cursor: 'pointer'
        }
      }
    },
    textDecorationNone: {
      textDecoration: 'none'
    },
    marginTB: {
      margin: '5px 0px 20px 0px'
    },
    lineHeightMD: {
      lineHeight: '40px'
    },
    commaCode:{
      paddingRight: 6,
      '&:last-child': {
        display: 'none'
      }
    },
    area200: {
      width: 200,
      display: 'inline-block'
    },
    //Custom DropDOwn
    customLink: {
      color: '#1D7DEA',
      cursor: 'pointer'
    },
    disable: {
      opacity: 0.4,
      backgroundColor: 'rgb(241 240 240) !important',
      color: '#333 !important',
      cursor: 'not-allowed !important'
    },
    overflowAuto: {
      overflow: 'inherit'
    },
    customDropdown: {
      position: 'relative'
    },
    variationSelect: {
      background: '#FFF',
      color: 'rgb(102 102 102)',
      marginRight: 6,
      border: '1px solid #dfdfdf',
      boxSizing: 'border-box',
      borderRadius: 4,
      fontSize: '16px',
      padding: '0 12px',
      maxWidth: '400px',
      height: '40px',
      lineHeight: '40px',
      fontFamily: "'Nunito', san-serif",   
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between' ,
      '& .selectBox': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: 330,
        textOverflow: 'ellipsis'
      }   
  },
  dropdownList:{
      background: '#FFF !important',
      color: 'rgb(102 102 102) !important',
      marginRight: 6,
      border: '1px solid #dfdfdf',
      boxSizing: 'border-box',
      borderRadius: 4,                
      maxWidth: '400px',
      width: '100%',
      minHeight: '40px',
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'hidden',
      fontFamily: "'Nunito', san-serif",
      position: 'absolute',
      zIndex: 9,
      textAlign: 'left', 
      display: 'block',   
      '&>div':{
          paddingLeft: '0px',
      },
  },
  listItem:{
      fontSize: '16px',
      color: '#666',
      textAlign: 'left',
      padding: '12px 14px',
      cursor: 'pointer',
      '&:hover':{
          color: '#333',
          backgroundColor: '#f1f1f1'
      }
  },
  arrowIcon:{
      '&>img':{
          transform: 'rotate(180deg)',
          marginLeft: '43px',
      }
  },
  pl0:{
      paddingLeft: '0!important',
  },
  
    // start role dialog styles
    roleFormElement: {
      // minHeight: 100,
      '& textarea': {
        padding: '12px 14px',
        marginTop: 0,
        color: 'rgb(102 102 102)',
        fontSize: 16,
        display: 'block',
        fontFamily: '"Nunito", sans-serif',
      }
    },
    customInputBox: {
      marginBottom: '11px',
      '& input': {
        background: 'rgb(255 255 255)',
        border: '1px solid rgb(223 223 223)',
        boxSizing: 'border-box',
        borderRadius: 4,
        maxWidth: 400,
        width: '100%',
        height: 40,
        padding: '12px 16px',
        color: 'rgb(102 102 102)',
        fontFamily: 'Nunito, sans-serif',
        fontSize: 16,
        '&:focus': {
          outline: 0,
        },
      }
    },
    autoCompleteBox: {
      position: 'relative',    
      '& .options': {
        position: 'absolute',
        background: 'rgb(255 255 255)',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: 8,
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: 130,
        padding: 0,
        maxWidth: '25rem',
        width: '100%',
        zIndex: 10,
        marginTop: 0,
        '&>li': {
          color: '#333',
          fontSize: 16,
          lineHeight: '20px',
          padding: '7px 12px',
          '&:hover': {
            background: 'rgb(247 247 247)'
          }
        }
      },
      '& .search': {
        maxWidth: 400,
        width: '100%',
        border: '1px solid rgb(223 223 223)',
        // overflowX: 'auto',
        // overflowY: 'hidden',
        borderRadius: 4,
        minHeight: 40
      },
      '& .chipInput': {
        marginLeft: 40,  
        // display: 'flex',
        alignItems: 'center',
        width: 'auto',
        // overflowX: 'auto',
        // overflowY: 'hidden',
        // minHeight: 40, 
        // maxHeight: 100,
        // overflow: 'auto',
        '& input': {          
          display: 'block',
          padding: '12px 4px',
          border: 'none',
          fontFamily: 'Nunito, san-serif',
          height: '38px',
        },
        '& .chipContainer': {
          display: 'flex',
          flexWrap: 'wrap',
          maxHeight: 100,
          overflow: 'auto',
        }
      },
      '& .option-active': {
        background: '#F7F7F7',
        fontSize: 16,
        color: '#333'
      },
      '& .search-btn': {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        display: 'block',
        padding: '0px 12px',
        background: 'rgb(255 255 255)',
        borderLeft: '1px solid rgb(223 223 223)',
        borderTop: '1px solid rgb(223 223 223)',
        borderBottom: '1px solid rgb(223 223 223)',
        borderBottomLeftRadius: 4,
        borderTopLeftRadius: 4,
        boxSizing: 'border-box',
      }
    },
    widthMD: {
      maxWidth: 766
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    customToaster:{ 
      position: "absolute",
      right: 20,
      top: 20,
      zIndex: 4,
      padding: '5px 16px 8px',
      borderRadius: 4,
      '&>h6': {
        color: '#fff',
        '&>:nth-child(2)': {
          padding: '0px 34px 0px 12px',
          fontSize: 16
        },
        '&>:nth-child(3)': {
          cursor: 'pointer'
        }
      }
    },
    successTooltip: {
      backgroundColor: '#43A047'
    },
    errorTooltip: {
      backgroundColor: '#F23C3C',
    },
    error: {
      color: '#F23C3C'
    },
    errorText: {
      color: '#F23C3C',
      verticalAlign: 'middle',
      marginTop: '3px',
      fontSize: '12px',
      '& svg': {
        verticalAlign: 'bottom'
      }
    },
    errorBorder: {
      border: "1px solid #F23C3C !important",
      borderRadius: "2px !important"
    },

    // End role dialog styles
    fontSize_SM: {
      fontSize: 16,
    },
    fontSize_MD: {
      fontSize: 18,
    },
    fontSize_LG: {
      fontSize: 20,
    },
    fontWeight_SM: {
      fontWeight: 400
    },
    fontSize24: {
      fontSize: 24
    },
    fontWeight_MD: {
      fontWeight: 600
    },
    black: {
      color: '#333333'
    },
    grey: {
      color: '#666666'
    },
    lightGrey: {
      color: '#999'
    },
    primary: {
      color: '#1D7DEA'
    },
    borderLight: {
      borderColor: '#DFDFDF'
    },
    marginZero: {
      marginLeft: 0
    },
    paddingTopSM: {
      padding: '16px 0px'
    },
    numberContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 16,
      '& svg': {
        width: 12
      },
      '&>span': {
        color: '#1D7DEA',
        fontSize: 16,
        fontWeight: 'bold',
        height: 26,
        '&>div:hover': {
          background: 'rgba(29, 125, 234, 0.08)',
          cursor: 'pointer'
        }
      },
      '&>div': {
        color: '#1D7DEA',
        fontSize: 16,
        fontWeight: 'bold',
        padding: '0px 8px',
        borderRadius: '50%',
        '&:hover': {
          background: 'rgba(29, 125, 234, 0.08)'
        }
      }
    },

    formControlElement: {
      marginRight: 30,
      marginLeft: 4
    },

    multiCheckedCheckbox: {
      backgroundColor: '#1d7dea !important',
      border: '1px solid #1d7dea !important',
      borderRadius: 2,
      opacity: 1,
      color: '#99a1a7',
      '&::before': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 4,
        width: 4,
        height: 8,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
      },
      '&:hover': {
        backgroundColor: '#1d7dea'
      }
    },
    multiCheckbox: {
      padding: 0,
      top: 0,
      left: 0,
      width: 16,
      height: 16,
      '-moz-appearance': 'none',
      color: 'rgb(204, 204, 204)',
      backgroundColor: '#fff',
      border: '1px solid #979797',
      borderRadius: 2,
      marginRight: 8,
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: 'Nunito',
        fill: '#979797',
        opacity: 0
      }
    },
    checkedCheckbox: {
      backgroundColor: '#1d7dea !important',
      border: '1px solid #1d7dea !important',
      borderRadius: 4,
      opacity: 1,
      color: '#99a1a7',
      '&::before': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
      },
      '&:hover': {
        backgroundColor: '#1d7dea'
      }
    },

    checkbox: {
      padding: 0,
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      '-moz-appearance': 'none',
      color: 'rgb(204, 204, 204)',
      backgroundColor: '#fff',
      border: '1px solid #979797',
      borderRadius: 4,
      marginRight: 14,
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: 'Nunito',
        fill: '#979797',
        opacity: 0
      }
    },
    primaryColor: {
      color: 'rgb(29 125 234)'
    },
    fontSizeSM: {
      fontSize: "0.75rem !important",
    },
    paddingBottomZero: {
      padding: 0
    },
    marginTopSM: {
      marginTop: 14
    },
    marginTopMD: {
      marginTop: 20
    },
    textCapitalize: {
      textTransform: "capitalize"
    },
    navTabsIndicator: {
      width: '80px!important',
      borderRadius: 10,
      height: 5,
      marginLeft: 16,
    },
    labelHeading:{
      fontSize: 18,
      minWidth: 110,
      '&>:nth-child(1)': {
        '&>span': {
          '&>span':{
            padding: 0
          }
        }
      }
    },
    selectedTab: {
      fontWeight: 600,
    },
    marginTop32:{
      marginTop: 32,
    },
    navbarRoot: {
      flexGrow: 1,
      backgroundColor: "rgb(0 0 0 / 0%)"
    },
    navPaperRoot: {
      boxShadow: 'none',
      backgroundColor: "rgb(0 0 0 / 0%)",
      '& .filterIcon': {
        border: 'solid 1px rgb(251 251 251)',
        background: 'rgb(251 251 251)',
        borderRadius: 4,
        padding: '8px 8px 0px',
        '&:hover': {
          background: 'rgb(222 217 217)',
          padding: '8px 8px 0px',
          cursor: 'pointer',
          borderRadius: 4,
          border: 'solid 1px rgb(251 251 251)'   
        }
      }
    },
    textSM: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 20,
      lineHeight: "16px",
      color: "rgb(51, 51, 51)",
    },
    tableRowFont: {
      color: "#666666",
      fontSize: 16,
      lineHeight: "16px",
    },
    topHeaderRoot: {
      margin: -15,
      padding: "0 14px",
      background: "rgb(255 255 255)",
      left: "80px",
      top: 0,
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      zIndex: 2,
      '&>:first-child': {
        padding: 10
      }
    },
    searchIcon: {
      fill: theme.palette.text.secondary,
      opacity: 0.5,
    },
    root: {
      width: "calc(100% - 80px)",
      padding: "0 14px",
      background: "rgb(255 255 255)",
      borderRadius: 4,
      // position: "fixed",
      left: "80px",
      top: 0,
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      zIndex: 2,
    },
    accessDeniedRoot: {
      display: "flex",
      height: "500px",
      alignItems: "center",
      background: "transparent"
    },
    tableFooter: {
      width: "100%",
    },
    table: {
      minWidth: 500,
      "& td": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    tableWrapper: {
      overflowX: "auto",
      background: "#FFFFFF",
      boxSizing: "border-box",
      borderRadius: 4,
    },
    tableHead: {
      boxSizing: "border-box",
      borderRadius: "4px 4px 0px 0px",
      height: 75,
    },
    tableCell: {
      maxWidth: 120,
      padding: "18px 20px",
      '&>a': {
        color: '#1D7DEA',
        fontSize: 16,
        textDecoration: 'none'
      },
      '& .tooltip': {
        display: 'none'
      },
      '& .opeacity50':{
        opacity: 0.5,
      },
      '&:hover':{
        '& .tooltip': {
          display: 'block',
          position: 'absolute',
          maxWidth: 210,
          whiteSpace: 'pre-line',
          background: 'rgb(51 51 51)',
          padding: 8,
          color: 'rgb(255 255 255)',
          borderRadius: 4,
          width: '100%',
          margin: '0px auto',
          marginTop: 10,
          textAlign: 'center',
          fontSize: 12,
          lineHeight: '18px',
          '&::before': {
            top: -8,
            left: '45%',
            width: 0,
            height: 0,
            content: '" "',
            position: 'absolute',
            marginLeft: -6,
            borderLeft: '5px solid rgb(0 0 0 / 0%)',
            borderRight: '5px solid rgb(0 0 0 / 0%)',
            borderBottom: '8px solid rgb(51 51 51)'
          }
        }
      }
    },
    tableRow: {
      "& td": {
        fontSize: 16,
        lineHeight: "16px",
        color: "#666666",
        "&:nth-child(4)": {
          color: "#333333",
        },
        "&:nth-child(1)": {
          color: "#333333",
        },
      },
      "&:nth-of-type(odd)": {
        backgroundColor: "#F8F8F8;",
      },
    },

    customPaper: {
      background: "rgb(255 255 255)",
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      marginTop: "32px",
      padding: "12px 26px",
    },
    headingFont: {
      fontWeight: 600,
      fontSize: 36,
      color: "#333333",
    },
    // root: {
    //   "&$checked": {
    //     color: "#1D7DEA !important",
    //   },
    //   "& label.MuiFormLabel-root": {
    //     fontSize: "1rem",
    //     color: "#33333",
    //   },
    //   "& p, a": {
    //     color: "#33333",
    //     fontSize: "1rem",
    //   },
    // },
    //styles for new client dialog//
    blueColor: {
      color: "#1D7DEA",
    },

    btnCreateGoal: {
      marginTop: 20,
    },

    cardContainer: {
      borderRadius: 4,
    },

    cardContentRoot: {
      padding: 0,
      "&:last-child": {
        padding: "20px",
      },
      backgroundColor: "#F7F7F7",
      background: "#F7F7F7",
    },

    cardContentBox: {
      // background: "#FFFFFF",
      background: "#fbfbfb",
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.287534)",
      borderRadius: 4,
      padding: 20,
      maxHeight: 470,
      height: "auto",
      overflowY: "auto",
    },

    chip: {
      margin: theme.spacing.unit,
    },

    chips: {
      display: "flex",
      flexWrap: "wrap",
      padding: "0px 5px",
    },

    classesDropdown: {
      border: "1px solid #DFDFDF",
      boxSizing: "border-box",
      borderRadius: 4,
      "& *:before": {
        border: "none !important",
      },
      width: "90%",
      minHeight: 36,
    },

    cancelIconStyle: {
      cursor: "pointer",
      "& svg": {
        color: "#848484",
        marginLeft: 12,
        marginTop: 8,
        position: "absolute",
      },
    },

    addMoreStyle: {
      cursor: "pointer",
    },

    classesList: {
      "& *ul": {
        height: 200,
      },
      "& svg": {
        color: "#848484",
        marginLeft: 12,
      },
    },

    chipClasses: {
      margin: "3px 5px 3px 3px",
      height: 28,
      background: "#EBEBEB",
      borderRadius: 36,
      color: "#666666",
    },

    dateIcon: {
      position: "absolute",
      marginLeft: -24,
      marginTop: 8,
      zIndex: 999,
      opacity: 1,
    },

    examDate: {
      "& *:before": {
        border: "none !important",
      },
      "& fieldset": {
        borderColor: "#dfdfdf !important",
      },
      "& input": {
        padding: 9,
      },
    },

    examDateRange: {
      display: "flex",
      width: "45%",
      "& > span": {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 16,
        color: "#333333",
        marginRight: 10,
        marginTop: 7,
      },
      // "& svg": {
      //   color: "#848484",
      //   marginLeft: 12,
      // },
    },

    textColor: {
      color: "#333333",
    },

    fontSizeLG: {
      fontSize: "1.75rem",
    },

    fontSizeMD: {
      fontSize: "1rem",
    },

    fontWeight500: {
      fontWeight: 500,
    },
    "& svg": {
      color: "#848484",
      marginLeft: 12,
    },

    greyText: {
      color: "#999",
    },

    careerTypeScrollbar: {
      maxHeight: 250,
    },
    permissionPlaceholderBorder: {
      border: '1px solid rgb(223 223 223)',
      boxSizing: 'border-box',
      borderRadius: 4,
      padding: '0px 20px 26px',
      marginBottom: 20,
      marginTop: 16,
      position: 'relative',
      color: '#666',
      '&>:nth-child(1)': {
        position: 'relative',
        top: -14,
        background: 'rgb(255 255 255)',
        padding: '0px 4px 0px 3px',
        fontSize: 20,
        fontFamily: "'Nunito', san-serif",
        '&>:nth-child(1)': {
          color: 'rgb(229 115 115)'
        }
      }
    },
    placeholderBorder: {
      border: '1px solid rgb(223 223 223)',
      boxSizing: 'border-box',
      borderRadius: 4,
      padding: '0px 20px 26px',
      marginBottom: 20,
      position: 'relative',
      color: '#666',
      '&>:nth-child(1)': {
        position: 'relative',
        top: -25,
        background: 'rgb(255 255 255)',
        padding: '0px 4px 0px 3px',
        fontSize: 20,
        fontFamily: "'Nunito', san-serif",
        '&>:nth-child(1)': {
          color: 'rgb(229 115 115)'
        }
      },
      
    },
    
    // Permission
    placeholderBorderModal: {
      border: '1px solid #999',
      boxSizing: 'border-box',
      fontFamily: 'nunito',
      borderRadius: 4,
      padding: 20,
      fontWeight: 'bold',
      marginBottom: 20,
      position: 'relative',
      width: '100%',
      marginTop: '43px',
      '&>:nth-child(1)': {
        position: 'absolute',
        top: '-11px',
        background: 'rgb(255 255 255)',
        padding: '0px 12px',
        fontSize: 20,
        '&>:nth-child(1)': {
          color: 'rgb(0, 0, 0)'
        }
      }
    },
    customModalWidth:{
      width: '790px',
      margin: 'auto',
    },
    textHeading:{
      marginTop: '21px',
      fontSize: 14,
      lineHeight: '19px',
      color: '#000',
    },
    subTxt:{
      fontSize: '16px',
      color: '#333',
      margin: '15px 0 0px 0',
    },
    permissionContent:{
      '&>ul':{
        paddingLeft: '15px',
        '&>li':{
          marginBottom: '16px',
          fontSize: 14,
          color: '#666',
          '&>span':{
            fontWeight: 'bold',
          }
        },
      },
    },
    // End
    customInputElement: {
      maxWidth: 400,
      minWidth: 400,
      minHeight: 40,
      background: 'rgb(255 255 255)',
      border: '1px solid rgb(223 223 223)',
      boxSizing: 'border-box',
      borderRadius: 4,
      padding: '0px 12px',
      '&:focus': {
        outline: 0
      }
    },
    paddingRight: {
      paddingRight: 30,
    },

    modal: {
      display: "flex",
      padding: 0,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 4,
      margin: "0px 0px 12px 83px",
      zIndex: 2
    },

    mt1x: {
      marginTop: 8,
    },

    marginBottomMD: {
      marginBottom: 24
    },

    modalHeader: {
      height: 66,
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      borderBottom: '1px solid #eee',
      backgroundColor: '#fff'
    },

    mb1x: {
      marginBottom: theme.spacing.unit,
    },

    paper: {
      width: "calc(100% - 0px)",
      height: "100%",
      // backgroundColor: "#fff",
      // boxShadow: theme.shadows[5],
      padding: "20, 40, 30",
      borderRadius: 4,
      outline: "#fff",
      marginLeft: "auto",
    },

    perfectScrollbar: {
      paddingTop: theme.spacing.unit * 2,
      maxHeight: "100vh",
      background: "rgb(255, 255, 255)",
      borderRadius: 4,
      "& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y": {
        opacity: 1,
      },
      paddingBottom: "140px",
      width: "100%",
      paddingRight: "40%",
    },
    paddingSM: {
      padding: "0px 10px",
    },

    textCenter: {
      textAlign: "center",
    },
    MyPATNoDataPanel: {
      padding: '13px 240px',
      textAlign: 'center',
      '& p': {
        lineHieght: '22px'
      }
    },
    widthLG: {
      width: "74%",
    },

    widthXL: {
      width: "80%",
    },
    title: {
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: "32px",
      textAlign: "left",
      paddingLeft: 18,
    },

    stepLabelTitle: {
      "& span:nth-of-type(2)": {
        "& span": {
          fontWeight: 700,
          color: "#333",
          textTransform: "uppercase",
        },
      },
    },
    labelCustomIcon: {
      width: "54px",
    },
    formTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "calc(100% - 80px)",
      display: "block",
      bottom: 0,
      marginRight: "auto",
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "24px",
      paddingBottom: "10px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    },
    cardContentStyle: {
      maxHeight: "calc(100vh - 130px)",
      overflow: "auto",
      minHeight: "calc(100vh - 130px)",
      margin: '0px 0px 0px 8px',
    },
    stepContentStyle: {
      marginLeft: "25px",
      paddingLeft: "35px",
    },
    closeContainer: {
      position: "relative",
    },
    closeButton: {
      top: "38px",
      right: "-35px",
      position: "absolute",
      backgroundColor: "#848484",
      padding: "2px",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#848484",
      },
    },
    connector: {
      marginLeft: "13px",
    },
    iconStyle: {
      "& img": {
        marginBottom: "5px",
      },
    },
    customCardFooter: {
      display: "flex",
      justifyContent: "flexEnd",
    },
    CustomCard: {
      padding: "32px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: "4px",
      marginBottom: 24
    },
    CardTitle: {
      fontWeight: 600,
      fontSize: 22,
      lineHeight: "32px",
      color: "#333333",
      marginBottom: 15,
    },
    customRadio: {
      marginRight: '35px',
    },
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '50px',
    },
    flagContainer: {
      position: "relative",
      display: "grid",
      gridTemplateColumns: "27% 73%",
      width: "100%",
      maxWidth: '400px',
      border: "1px solid #DFDFDF",
      borderRadius: "4px",
      height: "40px",
      lineHeight: "44px",
      padding: "0",
      "& > input": {
        border: "none",

      },
      "& img": {
        margin: "0 10px",
      },
    },
    flagContainerNew: {
      position: "relative",
      display: "grid",
      gridTemplateColumns: "27% 73%",
      width: "100%",
      maxWidth: '400px',
      border: "1px solid #DFDFDF",
      borderRadius: "4px",
      height: "40px",
      lineHeight: "44px",
      padding: "0",
      "& > input": {
        border: "none",
        padding: '0 16px',
        fontFamily: 'Nunito',
      },
      // },
      "& img": {
        margin: "0 10px",
      },
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: "10px",
      },
    },
    customInput: {
      border: "none",
      marginTop: '3px',
    },
    customSelect: {
      "& > div:nth-of-type(1)": {
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid #DFDFDF",
        height: '38px',
        padding: 0,
      },
    },
    inputWidth:{
      maxWidth: '400px',
      width: '100%',
      padding: 0,
      margin: 0,
      "& input":{
        height: '38px',
      },
    },
    btnGroup:{
      "& button":{
        margin: '5px',
        padding: '11px 32px',
        height: '44px',
      },
    },
    labelCustomWidth:{
      width: '122px',
    },
    resetButton:{
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: 0,
      backgroundColor: 'initial !important',
      color: '#666',
      padding: '0 !important',
      minWidth: 'initial',
      height: 'initial',
      marginRight: '30px !important',
    },
    activeNumber:{
      background: 'rgba(29, 125, 234, 0.08)',
      cursor: 'pointer',
      color: '#1D7DEA',
      fontSize: 16,
      fontWeight: 'bold',
      padding: '0px 8px',
      borderRadius: '50%',
    },
    customTextarea:{
      padding: '12px 0',
    },
    arrowIcons: {
      cursor: "pointer"
    },
    disablePointer: {
      cursor: "normal",
      opacity: 0.5
    },
    clientTitle:{
      marginTop: '12px',
    },
    marginB20:{
      marginBottom: '20px',
    },
    hideInput:{
      display: 'none !important',
    },
    restDialogCotent:{
      minWidth: '500px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      "& p":{
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '22px',
      },
    },
    resetHeading:{
      fontSize: 24,
      fontWeight: 600,
      lineHeight: '33px',
    },
    resetButtonEdit:{
      height: '36px',
      color: '#1d7dea',
    },
    customLabel:{
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '19px',
      // marginBottom: '10px',
    },
    headingText:{
      fontSize: 24,
      lineHeight: '18px',
      color: '#333',
      marginTop: 33,
    },
    roleTag:{
      fontSize: 10,
      fontWeight: 600,
      borderRadius: 4,
      width: 69,
      padding: 6,
      margin: 'auto'
    },
    bgPurple:{
      background: 'rgba(127, 90, 207, 0.1)',
      color: '#7F5ACF',
    },
    bgblue:{
      background: 'rgba(95, 138, 189, 0.1)',
      color: '#5F8ABD',
    },
    selectOrgStyle: {
      fontSize: '14px',
      color: 'gray'
    },
    customContainer: {
      padding: '10px 0',
      marginTop: '30px',
    },
    headingTxt:{
      color: "#333",
      fontSize: 24,
      lineHeight: '18px',
    },
    searchBar :{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      '&>div:nth-of-type(1)':{
        display: 'block',
        marginLeft: 20,      
      },
    },
    chipContainer:{
      '&>div:nth-of-type(1)':{
        margin: '0 10px',
      },
    },
    // Share
    allSections:{
      fontSize: 18,
      fontWeight: 600,
      color: '#1d7dea',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    marginTB10:{
      margin: '10px 0'
    },
    contentType:{
      fontSize: 20,
      fontWeight: 600,
      color: '#333',
      marginBottom: 20,
    },
    dialogCustomHeading:{
      fontSize: 24,
      fontWeight: 600,
      color: '#333'
    },
    searchBarChips:{
      height: 'auto',
      '&>div:nth-of-type(1)':{
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 5px',
        '&>div:nth-of-type(1)':{
          '&>div:nth-of-type(1)':{
            '&>div:nth-of-type(1)':{
              '&>div:nth-of-type(1)':{
                overflow: 'initial',
              }
            }
          }
        }
      },
      '& svg':{
        cursor: 'pointer'
      }
    },
    
    roleSubheading:{
      marginTop: '25px',
      marginBottom: '20px',
      'font-weight': '600',
      fontSize: 18,
      color: '#333',
    },
    marginTopSet:{
      marginTop:'0 !important',
    },
    widthSetThree:{
      'display': 'grid',
      'grid-template-columns': '13rem 13rem 13rem',
    },
    widthSetFour:{
      'display': 'grid',
      'grid-template-columns': '13rem 13rem 13rem 13rem',
      '& label':{
        marginRight: 15,
      },
    },
    marginBot20:{
      marginBottom:20,
    },
    positionSet:{
      padding:'0 10px',
      position:'absolute',
    },
  });
